module.exports = __webpack_public_path__ + "img/gotv.3c10cee5.svg";